/**
 * 入札一覧の左フィルターサイドバーの寸法。
 *
 * `FilterRail` (畳んだ時のレール) と `FilterToggleButton` (開閉トグル) の両方が
 * 参照するため、 コンポーネント側ではなく定数に置く。 `FilterRail` に置くと
 * `FilterRail` → `FilterToggleButton` → `FilterRail` の循環 import になる。
 */

/**
 * 畳んだ時のサイドバー列の幅。 8080 の `.sidebar.collapsed { width: 48px }` に
 * 合わせる。
 *
 * 開閉トグルの幅も同値にしている。 開いている時はトグルが見出し行の左端
 * 48px を占め、 畳むとレール自体が 48px になるので、 **どちらの状態でも
 * アイコン中心がサイドバー列の左端から 24px** に来る (= 同じ場所で連打できる)。
 */
export const FILTER_RAIL_WIDTH = '48px'
